import React from 'react'
import ErrorPage from '../components/ErrorPage'

function Refund() {
  return (
    <div>
      <ErrorPage/>
    </div>
  )
}

export default Refund
